angular.module('impactx.timeline').controller('TableTimelineCtrl', ['$scope', TableTimelineCtrl]);

function TableTimelineCtrl($scope) {
    var self = this;

    self.getLineCSS = function(index) {
        if($scope.data.entries.length === 1) {
            return 'table-timeline-line-single';
        }
        else if(index === 0) {
            return 'table-timeline-line-first';
        }
        else if(index === $scope.data.entries.length - 1) {
            return 'table-timeline-line-last';
        }
        else {
            return 'table-timeline-line';
        }
    }
}